<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="商家名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.storeName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="收银员姓名">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.cashierName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="收银员登录电话">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.accountPhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="消费者电话">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.consumerPhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">交易时间</span>
          <el-date-picker
            size="mini"
            v-model="createTime"
            @change="createTimeChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
          <el-button size="mini" type="primary" @click="handleAdd()"
            >新增</el-button
          >
          <!-- <el-popconfirm
            style="margin-left: 10px"
            title="确定删除吗？"
            @confirm="handleDelete()"
          >
            <template #reference>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-popconfirm> -->
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #way="slotData">
        <span v-if="slotData.data.row.way == 1">扫码</span>
        <span v-if="slotData.data.row.way == 2">手机号</span>
      </template>
    </e-table>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable },
  mixins: [listMixin],
  props: {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  data() {
    return {
      deleteKey: "userId",
      url: {
        list: "/wlBusiCashier/queryCashierOrders",
      },
      queryParam: {},
      createTime: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },

      //字段权限
      columns: [
        {
          field: "storeName",
          label: "商家名称",
        },
        {
          field: "consumerName",
          label: "消费者名称",
        },
        {
          field: "consumerPhone",
          label: "消费者电话",
        },
        {
          field: "amount",
          label: "交易金额",
        },
        {
          field: "cashierName",
          label: "收银员",
        },
        {
          field: "accountPhone",
          label: "收银员登录账号",
        },
        {
          field: "cashPhone",
          label: "收银员联系电话",
        },
        {
          field: "status",
          label: "方式",
          slotName: "way",
          columnType: "slot",
        },
        {
          field: "createTime",
          label: "交易时间",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    createTimeChange(date) {
      if (date) {
        this.queryParam.createTimeStart = date[0] + " 00:00:00";
        this.queryParam.createTimeEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.createTimeStart = "";
        this.queryParam.createTimeEnd = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.createTime = "";
      this.searchQuery();
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
    editOk() {
      this.loadData(1);
    },
    // handleDelete: function (id) {
    //   if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
    //     httpAction(this.url.delete, this.selectedRowKeys, "post").then(
    //       (res) => {
    //         if (res.code == 200) {
    //           //重新计算分页问题
    //           this.reCalculatePage(1);
    //           this.$message.success("删除成功");
    //           this.onClearSelected();
    //           this.loadData();
    //         } else {
    //           this.$message.warning(res.msg);
    //         }
    //       }
    //     );
    //   } else {
    //     this.$message.warning("请选择商品后删除");
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
